import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { CHAT_SKILLS_QUERY_KEY } from 'src/UI/app-container/chats/useChatSkills';
import type { SiestaSkill } from '../../manage-siesta-skills/types';

export default function useAddSkillLibraryEntry() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (entryId: string) => {
      const { data } = await api.post<SiestaSkill>(`/skill-library/${entryId}/add`);
      return data;
    },
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: ['tenant', 'custom-skills'] }),
        queryClient.invalidateQueries({ queryKey: CHAT_SKILLS_QUERY_KEY }),
        queryClient.invalidateQueries({ queryKey: ['skill-library'] }),
      ]);
    },
  });
}
